type ClassValue = string | number | null | undefined | boolean | ClassDictionary | ClassValue[];

type ClassDictionary = Record<string, boolean | null | undefined>;

function stringifyClassValue(value: ClassValue): string {
  if (Array.isArray(value)) {
    return value.map(stringifyClassValue).filter(Boolean).join(" ");
  }

  if (typeof value === "string" || typeof value === "number") {
    return value ? String(value) : "";
  }

  if (typeof value === "object" && value !== null) {
    return Object.entries(value)
      .filter(([, enabled]) => Boolean(enabled))
      .map(([key]) => key)
      .join(" ");
  }

  return "";
}

/**
 * Utility to conditionally join Tailwind/utility class names without external deps.
 */
export function cn(...values: ClassValue[]): string {
  return values.map(stringifyClassValue).filter(Boolean).join(" ");
}
